import React, { useEffect, useState } from "react";
import { 
  Skeleton,
  Typography,
  Box,
  Button,
  styled,
} from "@mui/material";
import { isMobile } from "react-device-detect";
import logoImage from "../../../../assets/images/logo.png"; // CORREGIDO: Eliminado "src/" del path
import callApi from "../../../../services/callApi"; // CORREGIDO: Agregado segundo nivel "../" para llegar a src/


// Styled components
const SubmitButton = styled(Button)(({ theme }) => ({
  fontSize: { xs: "14px", md: "16px", lg: "16px" },
  fontFamily: "Quicksand-Bold",
  backgroundColor: "#3B82F6",
  "&:hover": { 
    backgroundColor: "#3B82F6",
    boxShadow: "none !important",
  },
  "&:active": {
    backgroundColor: "#3B82F6",
    boxShadow: "none !important",
  },
  "&:focus": {
    backgroundColor: "#3B82F6",
    boxShadow: "none !important",
  },
  borderRadius: 5,
  width: "100%",
  color: "white",
  textTransform: "none",
  boxShadow: "none !important",
  transition: "none !important",
  "& .MuiTouchRipple-root": {
    display: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#E5E7EB",
    color: "#9CA3AF",
    boxShadow: "none !important",
  },
}));

function LinkPagoValidar() {
  const [sessionId, setSessionId] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [estadoPago, setEstadoPago] = useState("validando");

  useEffect(() => {
    // Scroll instantáneo a la parte superior
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const sessionIdParam = searchParams.get("session_id");

    setSessionId(sessionIdParam);

    if (sessionIdParam) {
      getPaymentData(sessionIdParam);
    }
  }, []);

  async function getPaymentData(sessionId) {
    if (!sessionId) return null;
    setLoading(true);

    try {
      const payment = await callApi(
        `/agenda/linkPagoValidar?session_id=${sessionId}`
      );
      
      setPaymentData(payment);

      // Evaluar el campo estado de la respuesta
      if (payment.success === true && payment.estado === "COMPLETADO") {
        setEstadoPago("aprobado");
      } else if (payment.success === true && payment.estado === "RECHAZADO") {
        setEstadoPago("rechazado");
      } else {
        setEstadoPago("rechazado");
      }
    } catch (error) {
      console.error("Error fetching payment data:", error);
      setEstadoPago("error");
    } finally {
      setLoading(false);
    }
  }

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString + "T00:00:00");
    const days = [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ];
    const months = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];

    const dayName = days[date.getDay()];
    const day = date.getDate().toString().padStart(2, "0");
    const month = months[date.getMonth()];

    return `${dayName} ${day} de ${month}`;
  };

  const transformModalidad = (modalidad) => {
    switch (modalidad) {
      case "consultorio":
        return "Consulta presencial";
      case "domicilio":
        return "Consulta a domicilio";
      case "online":
        return "Consulta online";
      case "telemedicina":
        return "Consulta online";
      default:
        return modalidad;
    }
  };

  const getTextoEncabezado = () => {
    switch (estadoPago) {
      case "validando":
        return "Procesando pago para:";
      case "aprobado":
        return "Pago confirmado para:";
      case "rechazado":
        return "Pago rechazado para:";
      case "error":
        return "Error al procesar para:";
      default:
        return "Procesando pago para:";
    }
  };

  const getTituloPrincipal = () => {
    switch (estadoPago) {
      case "validando":
        return "Procesando pago";
      case "aprobado":
        return "Pago confirmado";
      case "rechazado":
        return "Pago rechazado";
      case "error":
        return "Error al procesar pago";
      default:
        return "Procesando pago";
    }
  };

  const handleVolverAIntentar = () => {
    if (paymentData?.cobro?.id_cobro_sesion) {
      window.location.href = `/linkdepago/${paymentData.cobro.id_cobro_sesion}`;
    }
  };

  return (
    <>
      {/* LOGO */}
      <img
        src={logoImage}
        alt="Clinifica Logo"
        style={{
          width: isMobile ? "150px" : "200px",
          height: "auto",
          paddingTop: "15px",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          padding: 15,
        }}
      />

      {/* CAJA MORADA SUPERIOR */}
      <Box
        sx={{
          maxWidth: isMobile ? "94%" : "800px",
          width: isMobile ? "94%" : "90%",
          mx: "auto",
          bgcolor: "#fbfafe",
          boxShadow: 1,
          marginTop: 2,
          marginBottom: 2,
          borderRadius: 2,
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography sx={{ 
          fontFamily: "Quicksand-Regular",
          color: "#626262",
          fontSize: { xs: "14px", md: "16px" },
          mb: 0
        }}>
          {getTextoEncabezado()}
        </Typography>
        
        {loading ? (
          <>
            <Skeleton animation="wave" height={30} width="80%" />
            <Skeleton animation="wave" height={20} width="60%" />
            <Skeleton animation="wave" height={30} width="70%" />
            <Skeleton animation="wave" height={20} width="40%" />
            <Skeleton animation="wave" height={20} width="50%" />
            <Skeleton animation="wave" height={25} width="30%" />
            <Skeleton animation="wave" height={25} width="50%" />
          </>
        ) : paymentData ? (
          <>
            <Typography
              sx={{
                mt: -0.5,
                fontFamily: "Quicksand-Bold",
                fontSize: { xs: "18px", md: "20px" },
                color: "#191C1F",
                mb: 0
              }}
            >
              {paymentData.profesional?.nombre}
            </Typography>
            
            <Typography
              sx={{ 
                fontFamily: "Quicksand-Regular", 
                mt: -0.5,
                fontSize: { xs: "14px", md: "16px" },
                mb: 0
              }}
            >
              {paymentData.profesional?.profesion}
            </Typography>
            
            <Typography sx={{ 
              fontFamily: "Quicksand-Regular",
              color: "#626262",
              mt: 2,
              fontSize: { xs: "14px", md: "16px" },
              mb: 0
            }}>
              El servicio de:
            </Typography>
            
            <Typography
              sx={{
                mt: -0.5,
                fontFamily: "Quicksand-Bold",
                fontSize: { xs: "18px", md: "20px" },
                color: "#191C1F",
                mb: 0
              }}
            >
              {paymentData.sesion?.nombre_servicio}
            </Typography>
            
            <Typography
              sx={{ 
                fontFamily: "Quicksand-Regular", 
                mt: -0.5,
                fontSize: { md: "16px", xs: "14px" },
                color: "#191C1F",
                mb: 0
              }}
            >
              ${paymentData.cobro?.valor_cobro ? parseInt(paymentData.cobro.valor_cobro).toLocaleString("es-CL") : "0"}
            </Typography>
            
            <Box
              sx={{
                display: "inline-block",
                backgroundColor: "#f0f4ff",
                color: "#3B82F6",
                fontFamily: "Quicksand-Medium",
                fontSize: { md: "15px", xs: "13px" },
                borderRadius: 2,
                paddingLeft: 0.75,
                paddingRight: 0.75,
                paddingTop: 0.25,
                paddingBottom: 0.25,
                marginLeft: -0.75,
                mt: -0.75,
                textAlign: "left",
              }}
            >
              {transformModalidad(paymentData.sesion?.modalidad)}
            </Box>
            
            <Typography
              sx={{
                mt: 0,
                color: "#007FFF",
                fontFamily: "Quicksand-Bold",
                fontSize: { md: "16px", xs: "14px" },
              }}
            >
              {formatDate(paymentData.sesion?.fecha)} - {paymentData.sesion?.hora}
            </Typography>
          </>
        ) : (
          <Typography sx={{ fontFamily: "Quicksand-Regular" }}>
            No se pudo cargar la información del pago.
          </Typography>
        )}
      </Box>

      {/* TÍTULO PRINCIPAL */}
      <Typography
        sx={{
          fontFamily: "Quicksand-Bold",
          fontSize: { md: "24px", xs: "20px" },
          textAlign: "center",
          color: "#191C1F",
          mt: 3,
          mb: 1
        }}
      >
        {getTituloPrincipal()}
      </Typography>
      
      {/* CAJA BLANCA PRINCIPAL */}
      <Box
        sx={{
          maxWidth: isMobile ? "94%" : "800px",
          width: isMobile ? "94%" : "90%",
          mx: "auto",
          bgcolor: "white",
          boxShadow: 1,
          marginTop: 2,
          marginBottom: 8,
          borderRadius: 2,
          p: isMobile ? 2 : 4,
        }}
      >
        {loading ? (
          <Skeleton
            animation="wave"
            height={34}
            width="90%"
            sx={{ borderRadius: 1 }}
          />
        ) : estadoPago === "aprobado" ? (
          <>
            <Typography
              sx={{
                fontFamily: "Quicksand-Regular",
                fontSize: { xs: "14px", md: "16px" },
                color: "#191C1F",
                textAlign: "left",
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              <Box component="span" sx={{ fontWeight: "bold" }}>
                {paymentData?.paciente?.nombres} {paymentData?.paciente?.apellidos}
              </Box>
              , tu pago ha sido procesado exitosamente. Hemos enviado la confirmación de pago a{" "}
              <Box component="span" sx={{ fontWeight: "bold" }}>
                {paymentData?.paciente?.email}
              </Box>
            </Typography>
          </>
        ) : estadoPago === "rechazado" ? (
          <>
            <Typography
              sx={{
                fontFamily: "Quicksand-Regular",
                fontSize: { xs: "14px", md: "16px" },
                color: "#191C1F",
                textAlign: "left",
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              El pago no pudo ser procesado. Por favor, intenta nuevamente.
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
              <SubmitButton
                onClick={handleVolverAIntentar}
                disableRipple
                disableElevation
                disableFocusRipple
                variant="contained"
                sx={{
                  width: "auto",
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                VOLVER A INTENTAR
              </SubmitButton>
            </Box>

            <Typography
              sx={{
                fontFamily: "Quicksand-Regular",
                fontSize: { xs: "13px", md: "14px" },
                color: "#626262",
                textAlign: "center",
                lineHeight: 1.6,
              }}
            >
              Verifica que tu tarjeta tenga fondos suficientes o intenta con otro método de pago.
            </Typography>
          </>
        ) : estadoPago === "error" ? (
          <Typography
            sx={{
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
              color: "#191C1F",
              textAlign: "left",
              lineHeight: 1.6,
            }}
          >
            Ocurrió un error al procesar tu solicitud. Por favor, recarga esta página para intentar nuevamente. Si el problema persiste, contacta con el profesional.
          </Typography>
        ) : null}
      </Box>
    </>
  );
}

export default LinkPagoValidar;
